import { render, staticRenderFns } from "./TeamTestimonial.vue?vue&type=template&id=5d4b882a&scoped=true&"
import script from "./TeamTestimonial.vue?vue&type=script&lang=js&"
export * from "./TeamTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./TeamTestimonial.vue?vue&type=style&index=0&id=5d4b882a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b882a",
  null
  
)

export default component.exports